import { render, staticRenderFns } from "./TableMain2.vue?vue&type=template&id=b7388bd4"
import script from "./TableMain2.vue?vue&type=script&lang=js"
export * from "./TableMain2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7388bd4')) {
      api.createRecord('b7388bd4', component.options)
    } else {
      api.reload('b7388bd4', component.options)
    }
    module.hot.accept("./TableMain2.vue?vue&type=template&id=b7388bd4", function () {
      api.rerender('b7388bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/History/TableMain2.vue"
export default component.exports